import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 设备类型
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    
    // 屏幕尺寸
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    
    // 菜单状态
    menuVisible: false,
    
    // 搜索状态
    searchVisible: false,
    searchKeyword: '',
    
    // 用户认证状态
    isLoggedIn: false,
    userInfo: null,
    userToken: null,
    
    // IP检测状态
    ipInfo: null,
    isSpecialUser: false
  },
  
  getters: {
    deviceType: state => {
      if (state.isMobile) return 'mobile'
      if (state.isTablet) return 'tablet'
      return 'desktop'
    },
    
    isSmallScreen: state => state.screenWidth < 768,
    isMediumScreen: state => state.screenWidth >= 768 && state.screenWidth < 1024,
    isLargeScreen: state => state.screenWidth >= 1024,
    
    // 用户相关getters
    isAuthenticated: state => state.isLoggedIn && !!state.userToken,
    currentUser: state => state.userInfo,
    userNickname: state => state.userInfo ? (state.userInfo.nickname || state.userInfo.username) : null,
    userDisplayName: state => {
      if (state.userInfo) {
        return state.userInfo.nickname || state.userInfo.username || '用户'
      }
      return '用户'
    },
    
    // IP相关getters
    currentIp: state => state.ipInfo ? state.ipInfo.ip : null,
    ipMessage: state => state.ipInfo ? state.ipInfo.msg : null,
    isSpecialIpUser: state => state.isSpecialUser
  },
  
  mutations: {
    SET_DEVICE_TYPE(state, { isMobile, isTablet, isDesktop }) {
      state.isMobile = isMobile
      state.isTablet = isTablet
      state.isDesktop = isDesktop
    },
    
    SET_SCREEN_SIZE(state, { width, height }) {
      state.screenWidth = width
      state.screenHeight = height
    },
    
    TOGGLE_MENU(state) {
      state.menuVisible = !state.menuVisible
    },
    
    SET_MENU_VISIBLE(state, visible) {
      state.menuVisible = visible
    },
    
    TOGGLE_SEARCH(state) {
      state.searchVisible = !state.searchVisible
    },
    
    SET_SEARCH_KEYWORD(state, keyword) {
      state.searchKeyword = keyword
    },
    
    // 用户认证相关mutations
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      state.userToken = userInfo.token
      state.isLoggedIn = true
    },
    
    CLEAR_USER_INFO(state) {
      state.userInfo = null
      state.userToken = null
      state.isLoggedIn = false
    },
    
    INIT_USER_FROM_STORAGE(state) {
      const token = localStorage.getItem('userToken')
      const userInfo = localStorage.getItem('userInfo')

      // 获取env配置VUE_APP_REQUIRE_LOGIN
      const requireLogin = process.env.VUE_APP_REQUIRE_LOGIN;
      console.log('requireLogin', requireLogin);
      if (requireLogin === 'false') {
        state.isLoggedIn = true
        return
      }
      
      if (token && userInfo) {
        try {
          const parsedUserInfo = JSON.parse(userInfo)
          state.userInfo = parsedUserInfo
          state.userToken = token
          state.isLoggedIn = true
        } catch (error) {
          console.error('Failed to parse user info from localStorage:', error)
          // 清理无效数据
          localStorage.removeItem('userToken')
          localStorage.removeItem('userInfo')
          localStorage.removeItem('userId')
        }
      }
    },
    
    // IP相关mutations
    SET_IP_INFO(state, ipInfo) {
      state.ipInfo = ipInfo
      state.isSpecialUser = ipInfo ? ipInfo.isSpecialUser : false
    },
    
    CLEAR_IP_INFO(state) {
      state.ipInfo = null
      state.isSpecialUser = false
    }
  },
  
  actions: {
    // 初始化设备检测
    initDeviceDetection({ commit }) {
      const updateDeviceType = () => {
        const width = window.innerWidth
        const isMobile = width < 768
        const isTablet = width >= 768 && width < 1024
        const isDesktop = width >= 1024
        
        commit('SET_DEVICE_TYPE', { isMobile, isTablet, isDesktop })
        commit('SET_SCREEN_SIZE', { width, height: window.innerHeight })
      }
      
      updateDeviceType()
      window.addEventListener('resize', updateDeviceType)
    },
    
    toggleMenu({ commit }) {
      commit('TOGGLE_MENU')
    },
    
    setMenuVisible({ commit }, visible) {
      commit('SET_MENU_VISIBLE', visible)
    },
    
    toggleSearch({ commit }) {
      commit('TOGGLE_SEARCH')
    },
    
    setSearchKeyword({ commit }, keyword) {
      commit('SET_SEARCH_KEYWORD', keyword)
    },
    
    // 用户认证相关actions
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    
    logout({ commit }) {
      // 清理本地存储
      localStorage.removeItem('userToken')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('userId')
      
      // 清理Vuex状态
      commit('CLEAR_USER_INFO')
    },
    
    initAuth({ commit }) {
      commit('INIT_USER_FROM_STORAGE')
    },
    
    // IP相关actions
    async checkIpLogin({ commit }) {
      try {
        const ipCheckManager = await import('../utils/ipCheck')
        const ipInfo = await ipCheckManager.default.checkAndCacheIp()
        
        if (ipInfo) {
          commit('SET_IP_INFO', ipInfo)
        }
        
        return ipInfo
      } catch (error) {
        console.error('IP检测action失败:', error)
        return null
      }
    },
    
    async refreshIpInfo({ commit }) {
      try {
        const ipCheckManager = await import('../utils/ipCheck')
        const ipInfo = await ipCheckManager.default.forceRefreshIp()
        
        if (ipInfo) {
          commit('SET_IP_INFO', ipInfo)
        }
        
        return ipInfo
      } catch (error) {
        console.error('IP刷新action失败:', error)
        return null
      }
    },
    
    clearIpInfo({ commit }) {
      commit('CLEAR_IP_INFO')
    }
  }
})
